const getPrefersColorScheme = () => {
  if (window.matchMedia('(prefers-color-scheme)').media !== 'not all') {
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return isDark ? 'dark' : 'light';
  }
  return 'light';
};

const setLightTheme = () => {
  document.body.removeAttribute('dark');
  document.body.removeAttribute('black');
  document.querySelector('meta[name=theme-color]').content = '#fff';
};

const setDarkTheme = () => {
  document.body.setAttribute('dark', '');
  document.body.removeAttribute('black');
  document.querySelector('meta[name=theme-color]').content = '#212121';
};

const setBlackTheme = () => {
  document.body.setAttribute('dark', '');
  document.body.setAttribute('black', '');
  document.querySelector('meta[name=theme-color]').content = '#000';
};

const setTheme = (theme) => {
  switch (theme) {
    case 'auto': {
      const value = getPrefersColorScheme();
      setTheme(value);
      break;
    }
    case 'light': {
      setLightTheme();
      break;
    }
    case 'dark': {
      setDarkTheme();
      break;
    }
    case 'black': {
      setBlackTheme();
      break;
    }
    default: {
      break;
    }
  }
};

export default setTheme;
